module.exports = __webpack_public_path__ + "img/D201403_4.7502fade.jpg";